import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { ButtonToolbar, Button } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome';
import ReportStore from '../../stores/ReportStore';
import IframeModal from '../../component/element/IframeModal'
import PrintButtons from 'component/element/PrintButtons'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'

var NotificationSystem = require('react-notification-system');
class PickupRecord extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      data:[],
      fullname:'',
      year:'',
      month:''
    }
    this.refTableId = 'ReportPickup-'+Math.ceil(Math.random()*100);
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps) {

  }

  getTextMonth() {
    let month = this.props.month
    return month=='01'||month=='1' ? 'มกราคม' : month=='02'||month=='2' ? 'กุมภาพันธ์' : month=='03'||month=='3' ? 'มีนาคม' : month=='04'||month=='4' ? 'เมษายน' : month=='05'||month=='5' ? 'พฤษภาคม' : month=='06'||month=='6' ? 'มิถุนายน' : month=='07'||month=='7' ? 'กรกฎาคม' : month=='08'||month=='8' ? 'สิงหาคม' : month=='09'||month=='9' ? 'กันยายน' : month=='10' ? 'ตุลาคม' : month=='11' ? 'พฤศจิกายน' : month=='12' ? 'ธันวาคม' : ''
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadPickupRecord(year,month,name) {
    ReportStore.loadAllYearEmpStockMonth(year,month,name,(result)=> {
      this.setState({data:result.data,fullname:name,year:year,month:month})
    })  
  }

  onReportClose() {
    this.props.onReportClose()
  }

  onTableDetailCloseClick() {
    this.setState({fullname:'', year:'', month:''})
    if (this.props.onTableDetailCloseClick!=undefined)
      this.props.onTableDetailCloseClick()
  }

  onPrintClick() {
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url = './?startPage=PrintReportPickup&year='+this.props.year+'&month='+this.props.month+'&name='+this.props.requestBy
    } else{
      url = './pdf/v2/?startPage=PrintReportPickup&year='+this.props.year+'&month='+this.props.month+'&name='+this.props.requestBy
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานช่างเบิกของต่อเดือน '+this.state.fullname+' ประจำปี '+this.state.year+' เดือน '+this.getTextMonth(this.state.month)+'.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  renderItemList(items) {
    if (items.length===0) {
      return('')
    } else {
      return(
        items.map((item,index)=> {
          return(
            <div key={index}>
              - {item.description} จำนวน {item.quantity}
            </div>
          )
        })
      )
    }
  }

  renderRowData() {
    let {data} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=> {
          return(
            <tr key={index}>
              <td className='text-center'>{item.added_date.substr(0,10)}</td>
              <td className='text-center'>{item.added_date.substr(11,19)}</td>
              <td className='text-center'>{item.request_by}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.work_no}</td>
              <td>{this.renderItemList(item.items)}</td>
              <td className='text-right'>{this.getNumberFormat(item.cost_stock)}</td>
            </tr>
          )
        })
      )
    }  
  }

  renderTable() {
    return(
      <div className='table-responsive'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid table-tool' style={{marginBottom:'0'}}>
            <thead>
              <tr>          
                <th className='text-center' style={{ width: '100px' }}>วันที่</th>
                <th className='text-center' style={{ width: '100px' }}>เวลา</th>
                <th className='text-center' style={{ width: '150px' }}>ชื่อพนักงาน</th>
                <th className='text-center' style={{ width: '150px' }}>ทะเบียน</th>
                <th className='text-center' style={{ width: '120px' }}>ใบงาน</th>
                <th className='text-center' style={{ width: '120px' }}>รายการเบิก</th>
                <th className='text-center' style={{ width: '120px' }}>ต้นทุนสินค้า</th>
              </tr>  
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={6} className='text-right'>ยอดรวมสุทธิ</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummary('cost_stock'))}</th>
              </tr>
            </tfoot>
        </table>
      </div>
    )  
  }

  render() {
    let {loading} = this.state
    let {report} = this.props
    return(
      <div>
        <Box loading={loading}>
          <Box.Header border={true}>
            {
              report=='ReportCategoryPage'
              ?this.props.renderMenu
              :''
            }
            {
              report=='ReportPage'
              ?
              [<Box.Title>
                {'รายการเบิกอะไหล่ ชื่อ '+this.props.requestBy+' ประจำปี '+this.props.year+' เดือน '+this.getTextMonth()}  
              </Box.Title>,
              <Box.Tools>
                <Button className='bg-maroon'
                  onClick={this.onPrintClick.bind(this)}
                >
                  <FontAwesome name='print' />&nbsp;พิมพ์เอกสาร
                </Button> 
              </Box.Tools>]
              :''
            }
          </Box.Header>
          <Box.Body>
            {
              report=='ReportCategoryPage'
              ?<div className='' style={{marginBottom:'5px'}}>
                <PrintButtons
                  onPrintTable={this.onPrintClick.bind(this)}
                  onExportExcel={this.onExportExcel.bind(this)}
                  marginLeft='0'
                  width='auto'
                />
              </div>
              :''
            }
            {this.renderTable()}
          </Box.Body>
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              {
                report=='ReportCategoryPage'
                ?<Button bsStyle='default' onClick={this.onTableDetailCloseClick.bind(this)}><FontAwesome name='table' />&nbsp;กลับหน้าตารางหลัก</Button>
                :<Button onClick={this.onReportClose.bind(this)}><FontAwesome name='close'/>&nbsp;ปิด</Button>
              }
            </ButtonToolbar>
          </Box.Footer>
        </Box> 
        <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />     
      </div>
    )
  }
}

PickupRecord.defaultProps = {
  isReport:false,
  show:false,
  report:'ReportPage'
}

export default PickupRecord;  


// WEBPACK FOOTER //
// ./src/view/pu/PickupRecord.js